import { render, staticRenderFns } from "./StudyLecture.vue?vue&type=template&id=6a583dcd&"
import script from "./StudyLecture.vue?vue&type=script&lang=js&"
export * from "./StudyLecture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports